export enum NotificationContext {
    VendorInvite = "VendorInvite",
    VendorMFA = "VendorMFA",
    VendorApplication = "VendorApplication",
    VendorFeedback = "VendorFeedback",
    AdminFeedback = "AdminFeedback",
    UserEvent = "UserEvent",
    Special = "Special"
}
